import clsx from 'clsx'
import React, { CSSProperties, FC } from 'react'

import { SliderData } from '@Components/Slider'

import styles from './SliderIndicator.module.scss'

export interface SliderIndicatorProps {
  className?: string
  sliderState: SliderData | null
  style?: CSSProperties
}

export const SliderIndicator: FC<SliderIndicatorProps> = ({ className, sliderState, style }) => (
  <input
    className={clsx(className, styles.sliderIndicator, (!sliderState || !sliderState.isScrollable) && styles.hidden)}
    max={sliderState?.rangeMax ?? 0}
    min={sliderState?.rangeMin ?? 0}
    onChange={() => null}
    readOnly
    style={style}
    type="range"
    value={sliderState?.rangeValue ?? 0}
  />
)

